import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp, Users, MessageCircle } from "lucide-react";
import heroImage from "@/assets/HeroSectionFoto.optimized.webp";
import heroImageMobile from "@/assets/HeroSectionFoto.mobile.webp";

const stats = [
  { icon: TrendingUp, value: "200+", label: "Klanten geholpen" },
  { icon: Users, value: "95%", label: "Tevreden klanten" },
  { icon: MessageCircle, value: "8+", label: "Jaar ervaring" },
];

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          srcSet={`${heroImageMobile} 960w, ${heroImage} 1600w`}
          sizes="100vw"
          width={1600}
          height={1067}
          alt="Sales coaching"
          className="w-full h-full object-cover"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 hero-section opacity-85" />
      </div>

      <div className="container mx-auto px-4 relative z-10 pt-24 pb-16">
        <div className="max-w-2xl">
          <p className="text-accent font-semibold text-sm uppercase tracking-widest mb-4">
            Sales Coaching & Strategie
          </p>

          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-primary-foreground leading-tight mb-6">
            Meer klanten.{" "}
            <span className="text-gradient-gold">Betere gesprekken.</span>{" "}
            Hogere omzet.
          </h1>

          <p className="text-primary-foreground/80 text-lg md:text-xl leading-relaxed mb-10 max-w-lg">
            Ontdek hoe je met bewezen strategieën en persoonlijke coaching jouw sales naar het volgende niveau tilt.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/contact"
              className="gold-gradient text-accent-foreground px-8 py-4 rounded-md font-semibold shadow-gold hover:opacity-90 transition-all inline-flex items-center justify-center gap-2 text-base"
            >
              Plan een gratis intake
              <ArrowRight size={18} />
            </Link>
            <Link
              to="/diensten"
              className="border border-primary-foreground/30 text-primary-foreground px-8 py-4 rounded-md font-semibold hover:bg-primary-foreground/10 transition-all inline-flex items-center justify-center text-base"
            >
              Bekijk diensten
            </Link>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 grid grid-cols-3 gap-8 max-w-lg">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center sm:text-left">
              <stat.icon className="text-accent mb-2 mx-auto sm:mx-0" size={20} />
              <p className="text-2xl md:text-3xl font-serif font-bold text-primary-foreground">{stat.value}</p>
              <p className="text-xs text-primary-foreground/60 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
